import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';

@Injectable({ providedIn: 'root' })
export class RouteFunctionReportApiService {
  async postRaw<T>(endpoint: string, model: Record<string, unknown>): Promise<T> {
    const response = await axios.post(endpoint, model);
    return response.data as T;
  }
  async post<T>(endpoint: string, model: Record<string, unknown>): Promise<T> {
    const response = await axios.post(endpoint, model);
    return (typeof response.data === 'string' ? JSON.parse(response.data) : response.data) as T;
  }
}
